/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'enumToArray'
})
export class EnumToArrayPipe implements PipeTransform {

  transform(value): object {
    return Array.from(Object.keys(value));


  }

}
